module.exports = ".no-wrap{\r\n  white-space: nowrap;\r\n  padding: 0px 8px 0px 8px;\r\n  text-overflow: ellipsis;\r\n  overflow: hidden;\r\n}\r\n"